import { render, staticRenderFns } from "./Fertilization.html?vue&type=template&id=40471999&external"
import script from "./Fertilization.js?vue&type=script&lang=js&external"
export * from "./Fertilization.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports